import React, { useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PrivacyTermsConditions from "../../Components/PrivacyTermsConditions/PrivacyTermsConditions";
import { userId } from "../../Utils/LocalStorage";
import Loader from "../../Components/Loader/Loader";
import { NotificationsAPI } from "../../Utils/Api/NotificationsAPI";
import { useEffect } from "react";

const Notifications = (props) => {
  //read More
  const [readMore, setreadMore] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [indexValue, setIndexValue] = useState("");
  const [loading, setLoading] = useState(false);

  const userid = userId();

  const navigate = useNavigate();

  const NotificationsApiHandler = async () => {
    const data = {
      user_id: parseInt(userid),
      user_type: "business_user",
    };
    setLoading(true);
    const NotificationList = await NotificationsAPI(data, () => {
      navigate("/");
    });
    setNotificationData(NotificationList.data);
    setLoading(false);
  };

  const ReadmoreHandler = (i) => {
    setreadMore(!readMore);
    setIndexValue(i);
  };

  const d = new Date();

  let CurrentDate =
    d.getDate() + "-" + (d.getMonth() + 1) + "-" + d.getFullYear();

  useEffect(() => {
    NotificationsApiHandler();
  }, []);

  // const extraContentRead = (
  //   <div>
  //     <p className="extra-content">
  //       Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide
  //       fökarad benim. Porade deneheten i operaosmos då memåska att agnostipod.
  //       Häde jåskapet novent men nyrölig och ugt. Prett löst blåljusyrke bekyska
  //       eller måse. Lörem ipsum sesosa ultrahet plankning kys. Åbel
  //       kompetensväxling jide fökarad benim. Porade deneheten i operaosmos då
  //       memåska att agnostipod. Häde jåskapet novent men nyrölig och ugt. Prett
  //       löst blåljusyrke bekyska eller måse.
  //     </p>
  //   </div>
  // );

  // const linkNameRead = readMore ? "Read Less" : "Read More";
  return (
    <>
      {loading === true ? <Loader /> : <></>}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to={"/"}>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">Notifications</p>

          {notificationData?.length !== 0 ? (
            notificationData.map((data, index) => {
              let Description1 = data.content.substring(0, 200);

              let Description2 = data.content.substring(
                200,
                data.content?.length
              );

              const extraContentRead = (
                <div>
                  <p className="extra-content" style={{ color: "black" }}>
                    {Description2}
                  </p>
                </div>
              );

              const linkNameRead =
                indexValue === index && readMore ? "Read Less" : "Read More";

              // date
              const DateValue = new Date(data.created_at);
              const shortMonth = DateValue.toLocaleString("en-US", {
                month: "short",
              });
              const day = DateValue.toLocaleString("en-US", {
                day: "numeric",
              });
              const year = DateValue.toLocaleString("en-US", {
                year: "numeric",
              });
              const finaldate = day + "-" + shortMonth + "-" + year;

              return (
                <>
                  <p className="redeemed-date">{finaldate}</p>

                  <div className="border-card">
                    <p className="border-card-text" style={{ color: "black" }}>
                      {data.heading}
                    </p>
                    <p style={{ color: "black" }}>
                      {Description1}

                      {indexValue === index ? readMore && extraContentRead : ""}

                      <span
                        className="read-more-link mb-2"
                        style={{
                          cursor: "pointer !important",
                          color: "black",
                        }}
                        onClick={() => {
                          ReadmoreHandler(index);
                        }}
                      >
                        {data.content?.length > 200 ? [linkNameRead] : ""}
                      </span>
                    </p>
                  </div>
                </>
              );
            })
          ) : (
            <div
              style={{
                padding: "1rem 1rem 1rem 0.5rem",
                fontSize: "1.5rem",
                color: "black",
              }}
            >
              No notifications are available.
            </div>
          )}
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default Notifications;
